import makeUseCellFilterAction, {
  UseCellFilterActionProps,
} from "ds/components/Table/helpers/makeUseCellFilterAction";

import { SEARCH_MODULES_SUGGESTIONS_DICTIONARY } from "../FiltersLayout/constants";
import useModulesAnalytics from "../useModulesAnalytics";

const useCellFilterAction = (props: UseCellFilterActionProps) => {
  return makeUseCellFilterAction({
    trackAnalytics: useModulesAnalytics(),
    searchSuggestionsDictionary: SEARCH_MODULES_SUGGESTIONS_DICTIONARY,
  })(props);
};

export default useCellFilterAction;
